enum NodeTypes {
    actionNode = 'action-node',
    botMessageNode = 'bot-message-node',
    userIntentNode = 'user-intent-node',
    startNode = 'start-node'
}

export default NodeTypes;
